import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {InfluencerGroup, InfluencerGroups} from '../../../../models/influencer-group';
import {GroupService} from '../../../services/group-details/group.service';
import {UserService} from '../../../services/user.service';
import {NumberUtils} from '../../../utils/number.utils';
import {ErrorTemplate} from '../../../../models/ErrorTemplate';
import {ValidationHandlerService} from '../../../core/validation-handler.service';
import {AchooUserAvatarComponent} from '../../../core/achoo-user-avatar/achoo-user-avatar.component';
import {PlaceholderVisibilityService} from '../../../services/placeholder-visibility/placeholder-visibility.service';
import {CommonConstant, RecentlyVisitedInfluencerGroup} from '../../../app.constants';
import {Router} from '@angular/router';
import {
  ActionDetails,
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';
import {CacheService} from '../../../services/cache/cache.service';
import {AppSettings} from '../../../utils/app-settings';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {GroupVersion, NewInfluencerGroup} from '../../../../models/auto-group/auto-group-setting';
import {NewGroupSettingsComponent} from '../../group-details/new-group-settings/new-group-settings.component';

enum GroupActionType {
  DELETE = 'delete',
  VIEW = 'view'
}

@Component({
  selector: 'group-item',
  templateUrl: './group-item.component.html',
  styleUrls: ['./group-item.component.scss']
})
export class GroupItemComponent implements OnInit {
  static UPDATE_CONFIG = 'update config';
  static ADD_INFLUENCER = 'add influencer';
  public showGroupSetting = false;
  public isRequestReview = false;

  @ViewChild('SaveGroupSettingError')
  saveGroupSettingError: AchooPopupComponent;
  @ViewChild('newGroupSetting')
  newGroupSetting: NewGroupSettingsComponent;

  @Input()
  public influencerGroup: InfluencerGroups;

  @Input() influencerGroupList: any = [];

  @Output()
  public eventAddInfluencerGroup = new EventEmitter<any>();

  @Output()
  public eventDeleteInfluencerGroup = new EventEmitter<any>();

  @Input()
  public listProjectOfAdvertiser: any  = [];

  @Input()
  public isLoadingRecentlyVisitedInfluencerList: boolean;

  @ViewChildren(AchooUserAvatarComponent)
  displayInfluencers: QueryList<AchooUserAvatarComponent>;

  @Output() editGroupEvent = new EventEmitter<any>();
  @Output() editOrCreateProjectEvent: EventEmitter<any> = new EventEmitter<any>();

  isRecentlyVisitedInfluencerGroup: boolean;
  influencerGroupData: InfluencerGroup | NewInfluencerGroup;
  public isUpdatingGroupInfo = false;

  constructor(private groupService: GroupService,
              private router: Router,
              private validationHandlerService: ValidationHandlerService,
              private placeholderVisibilityService: PlaceholderVisibilityService,
              private cacheService: CacheService,
              private userService: UserService,
              private eventTracker: EventTrackerService,
              private modalService: ModalService) {
  }

  ngOnInit () {
    this.isRecentlyVisitedInfluencerGroup = this.influencerGroup.name === RecentlyVisitedInfluencerGroup.name ? true : false;
    this.isRequestReview = AppSettings.isRequestReview();
    if (!this.isRecentlyVisitedInfluencerGroup) {
      this.loadInfluencerGroup(this.influencerGroup.id);
    }
  }

  normalizeNumberData(value: number): string {
    return NumberUtils.normalizeNumberToString(value);
  }

  executeAddInfluencerGroup() {
    this.eventAddInfluencerGroup.emit(this.influencerGroup);
  }

  executeDeleteInfluencerGroup() {
    this.eventDeleteInfluencerGroup.emit(this.influencerGroup);
  }

  executeEditInfluencerGroup() {
    if (this.showGroupSetting) {
      this.showGroupSetting = false;
      setTimeout(() => {
        this.reloadGroupData(this.influencerGroup.id);
      }, 100);
    } else {
      this.showGroupSetting = true;
    }
  }

  private reloadGroupData(groupId) {
    this.influencerGroupData = null;
    this.loadInfluencerGroup(groupId);
  }

  openGroupDetails(activeAccount) {
    this.cacheService.disableCacheRemoving();
    if (this.isRecentlyVisitedInfluencerGroup) {
      return this.router.navigate(['groups', 'monthly-visit'], {
        queryParams: {activeAccount}
      });
    }
    return this.router.navigate([`/groups/${this.influencerGroup.id}`], {
      queryParams: {activeAccount}
    });
  }

  get numberRemaingInfluencer() {
    if (!this.influencerGroup) {
      return 0;
    }

    const numOfRemaining = this.influencerGroup.totalInfluencers - this.influencerGroup.influencers.length;

    // we're limiting the max number of influencer in group is 1000
    return numOfRemaining >= CommonConstant.MAX_INFLUENCERS_INTO_GROUP ? CommonConstant.MAX_INFLUENCERS_INTO_GROUP + 1 : numOfRemaining;
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  invalidActionData(actionType) {
    let params;
    if (actionType === GroupItemComponent.UPDATE_CONFIG || actionType === GroupItemComponent.ADD_INFLUENCER) {
      params = {
        action: UserActionType.UPDATE,
        source: ActionSource.PAGE,
        actionDetails: actionType === GroupItemComponent.UPDATE_CONFIG ? ActionDetails.UPDATE_CONFIG : ActionDetails.ADDED_INFLUENCERS,
      };
    } else {
      params = {
        action: actionType === GroupActionType.DELETE ? UserActionType.DELETE
          : actionType === GroupActionType.VIEW ? UserActionType.VIEW : UserActionType.UPDATE,
        source: ActionSource.PAGE
      };
    }
    return {
      action: UserActionType.ACTION,
      item: Page.GROUP,
      target: {
        type: TargetType.INFLUENCER_GROUP
      },
      params,
      activePage: {
        type: ActivePages.GROUP_OVERVIEW,
      }
    };
  }

  get showLoader() {
    if (this.influencerGroup.name === RecentlyVisitedInfluencerGroup.name && this.isLoadingRecentlyVisitedInfluencerList) {
      return true;
    }
    return false;
  }

  get showTotalPendingInfluencer() {
    return this.influencerGroup.totalPendingInfluencers > 0 && !this.isRecentlyVisitedInfluencerGroup && this.isRequestReview;
  }

  get openNewGroupSetting() {
    return this.influencerGroupData;
  }

  private loadInfluencerGroup(influencerGroupId) {
    this.cacheService.get(`InfluencerGroupDetail${influencerGroupId}`, this.groupService.getInfluencerGroup(influencerGroupId)).subscribe(res => {
      this.influencerGroupData = res ? res : null;
    });
  }

  updateGroupEvent(evt) {
    this.editGroupEvent.emit(evt);
  }

  updateNewValueForCachedData(groupId, newData) {
    if (this.cacheService.has(`influencer_group_data_${groupId}`)) {
      this.cacheService.set(`influencer_group_data_${groupId}`, newData);
    }
  }

  editOrCreateProject(project) {
    this.editOrCreateProjectEvent.emit(project);
  }

  beforeSubmitGroupSetting() {
    this.showGroupSetting = false;
  }

  afterSubmitGroupSetting(evt) {
    if (evt.isError) {
      this.showGroupSetting = true;
      this.modalService.open(this.saveGroupSettingError, null, true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/group-item/group-item.component.ts